import {ChangeDetectorRef, Component, Inject, ViewChild, ViewContainerRef} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {DetailPopup} from '../../../mapping-classes/detail-popup';
import {DetailPopupRequestModel} from '../../../services/popup/detail-popup-request.model';
import * as DetailTable from '../../../table-lib';
import {DomService} from '../../../../../../services/dom-service/dom.service';
import {CommissionDataComponent} from '../../shared/commission-data.component';
import {CommissionTableComponent} from '../../../detail-table/commission/commission-table.component';
import {formatCurrency, formatNumber} from '@angular/common';

@Component({
  selector: 'app-detail-table',
  templateUrl: './commission-popup.component.html',
  styleUrls: ['../../../detail-screen/detail-screen.component.css'],
})

export class CommissionPopupComponent implements DetailPopup {
  @ViewChild('table', {read: ViewContainerRef}) tableContainer: ViewContainerRef;
  @ViewChild('sub_panel', {read: ViewContainerRef}) subPanelContainer: ViewContainerRef;

  title: string;
  restrictedData: boolean;
  errorText: string;
  data;
  hasData = true;
  tableInstance;
  tableComponent;
  minimumRate;
  maximumRate;
  flatRate;
  emptyValuePlaceholder = '-';
  shieldedText = 'Afgeschermd';

  constructor(private domService: DomService, private changeRef: ChangeDetectorRef,
              public dialogRef: MatDialogRef<CommissionPopupComponent>,
              @Inject(MAT_DIALOG_DATA) public inputData: any) {
    this.title = 'Provisie afspraken tabel: ' + DetailPopupRequestModel.tableNumber;

    if (inputData.listOfError && inputData.listOfError.length !== 0) {
      this.createErrorMessage(inputData);
      this.hasData = false;
    } else if (inputData.detailsViewObject) {
      this.data = inputData;
      this.restrictedData = inputData.detailsViewObject['restrictedData'];
    }
  }

  ngAfterViewInit() {
    this.addValues(this.data);
    this.changeRef.detectChanges();
  }

  close(): void {
    this.dialogRef.close();
  }

  createErrorMessage(response) {
    if (response.listOfError && response.listOfError.length !== 0) {
      if (response.listOfError[0].code === 'CIV_F025') {
        this.errorText = 'Geen detail gegevens gevonden.';
      } else if (response.listOfError[0].code) {
        this.title = 'Provisie afspraken';
        this.errorText = 'Provisie afspraken niet gevonden.';
      }
    }
  }

  addValues(response) {
    const detailsViewObject = response.detailsViewObject;
    this.createTable(detailsViewObject);
    if (response.detailsViewObject.restrictedData) {
      this.minimumRate = this.shieldedText;
      this.maximumRate = this.shieldedText;
      this.flatRate = this.shieldedText;
    } else {
      this.minimumRate = CommissionDataComponent.minimumRate;
      this.maximumRate = CommissionDataComponent.maximumRate;
      this.flatRate = CommissionDataComponent.flatRate;
    }
  }

  private createTable(detailsViewObject) {
    this.tableInstance = new DetailTable['Commission'](detailsViewObject);
    if (!this.tableContainer) {
      return null;
    }

    this.tableComponent = this.createCommissionTable();
  }

  private createCommissionTable() {
    const viewRef = this.domService.addComponentToDOM(CommissionTableComponent, this.tableContainer);
    const tableComponentToReturn = viewRef.instance as CommissionTableComponent;
    return this.setBasicComponentValues(tableComponentToReturn);
  }

  private setBasicComponentValues(componentToReturn) {
    componentToReturn.errorText = this.tableInstance.errorText;
    componentToReturn.showTable = (componentToReturn.errorText === null || componentToReturn.errorText === undefined);
    componentToReturn.restrictedData = this.restrictedData;
    componentToReturn.tableColumns = this.tableInstance.rowHeaders;
    componentToReturn.tableData = this.tableInstance.rowData;
    return componentToReturn;
  }
  getAmountInPercentage(value) {
    if (this.restrictedData) {
      return value;
    } else {
      if (value || value === 0) {
        value = formatNumber(value, 'en-US', '1.3-3');
      } else {
        value = this.emptyValuePlaceholder;
      }
      return value;
    }
  }
}
